import React from 'react';
import { Spinner } from 'reactstrap';

const LazyLoading = () => (
  <div className='text-center'>
    <Spinner style={{ width: '2rem', height: '2rem' }} />
  </div>
);

export default LazyLoading;
